import React from 'react'
import { Link } from 'react-router-dom'
import { getOptimizedImageUrl } from '../lib/cms'

export default function TripCard({ trip }) {
  const imageUrl = Array.isArray(trip.hero_billede)
    ? trip.hero_billede[0]
    : trip.hero_billede

  const slug = trip.url_slug || trip.slug?._ || trip.id

  return (
    <div className="bg-slate-900 rounded-2xl border border-slate-800 overflow-hidden flex flex-col hover:border-slate-700 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-950/20 group">
      {/* Image Banner */}
      <div className="relative h-56 overflow-hidden">
        <img
          src={getOptimizedImageUrl(imageUrl, 600, 80)}
          alt={trip.rejsenavn}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/20 to-transparent" />

        {/* Badges */}
        <div className="absolute top-3 left-3 flex flex-wrap gap-2">
          {trip.land && (
            <span className="bg-slate-950/80 backdrop-blur-md text-cyan-300 text-xs font-semibold px-2.5 py-1 rounded-lg border border-slate-700">
              <i className="fa-solid fa-earth-europe mr-1.5" aria-hidden="true" />
              {trip.land}
            </span>
          )}
          {trip.rejsetype && (
            <span className="bg-cyan-950/80 backdrop-blur-md text-cyan-300 text-xs font-medium px-2.5 py-1 rounded-lg border border-cyan-800/60">
              {trip.rejsetype}
            </span>
          )}
        </div>

        {trip.ledighed && (
          <div className="absolute top-3 right-3 bg-amber-500/20 backdrop-blur-md border border-amber-500/40 text-amber-300 text-xs font-medium px-2.5 py-1 rounded-lg">
            {trip.ledighed}
          </div>
        )}

        <div className="absolute bottom-3 left-3 right-3">
          <span className="text-xs font-semibold uppercase tracking-wider text-cyan-400">
            {trip.destination}
          </span>
          <h3 className="font-heading font-bold text-xl text-white line-clamp-1 group-hover:text-cyan-300 transition-colors">
            {trip.rejsenavn}
          </h3>
        </div>
      </div>

      {/* Content Details */}
      <div className="p-5 flex-1 flex flex-col justify-between space-y-4">
        <p className="text-slate-300 text-sm line-clamp-2 leading-relaxed">
          {trip.kort_beskrivelse}
        </p>

        <div className="grid grid-cols-2 gap-2 text-xs text-slate-400 bg-slate-950/50 p-3 rounded-xl border border-slate-800/60">
          {trip.afrejsedato && (
            <div className="flex items-center gap-2">
              <i className="fa-regular fa-calendar-days text-cyan-400" aria-hidden="true" />
              <span>{trip.afrejsedato}</span>
            </div>
          )}
          {trip.varighed && (
            <div className="flex items-center gap-2">
              <i className="fa-regular fa-clock text-cyan-400" aria-hidden="true" />
              <span>{trip.varighed}</span>
            </div>
          )}
          {trip.hotel && (
            <div className="col-span-2 flex items-center gap-2 truncate">
              <i className="fa-solid fa-hotel text-cyan-400 shrink-0" aria-hidden="true" />
              <span className="truncate">{trip.hotel}</span>
            </div>
          )}
        </div>

        {/* Price & CTA */}
        <div className="pt-2 border-t border-slate-800 flex items-center justify-between gap-2">
          <div>
            <span className="text-xs text-slate-400 block">Fra kun</span>
            <div className="flex items-baseline gap-1">
              <span className="font-heading font-extrabold text-2xl text-white">
                {trip.pris ? trip.pris.toLocaleString('da-DK') : 'TBA'}
              </span>
              <span className="text-xs font-bold text-cyan-400">DKK</span>
            </div>
          </div>

          <Link
            to={`/skirejser/${slug}`}
            className="px-4 py-2.5 rounded-xl bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-bold text-xs uppercase tracking-wider transition-colors inline-flex items-center gap-1.5 shadow-md shadow-cyan-500/20"
          >
            <span>Se rejse</span>
            <i className="fa-solid fa-arrow-right" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </div>
  )
}
